import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { getWatchLists } from "../../redux/new-insight/actions";
import { FaArrowDownLong, FaArrowUpLong } from "react-icons/fa6";
import { FaFire } from "react-icons/fa";
import SortBy from "../../ui/SortBy";
import TrendsTable from "./watchlist/TrendsTable";
import DisplayModeSwitcher from "./watchlist/DisplayModeSwitcher";
import PageHeader from "../../ui/PageHeader";
import { useSearchParams } from "react-router-dom";
import SearchBox from "../../ui/SearchBox";
import WatchlistSummaryBoard from "./watchlist/WatchlistSummaryBoard";

function InsightWatchlist() {
  const {
    main: { userData },
    newInsightState: { watchlists, watchlistStatus, watchlistsFetched },
  } = useSelector((state) => state);
  const [searchParams, setSearchParams] = useSearchParams();
  const trendsSearch = searchParams.get("search") || "";

  const dispatch = useDispatch();

  const searchHandler = (e) => {
    const searchValue = e.target.value.trim().toLowerCase();
    searchParams.set("search", searchValue);
    setSearchParams(searchParams);
  };

  const sortOptions = [
    {
      value: "tops",
      label: "Top coins",
      icon: <FaFire />,
    },
    {
      value: "losers",
      label: "Losers",
      icon: <FaArrowDownLong />,
    },
    {
      value: "gainers",
      label: "Gainers",
      icon: <FaArrowUpLong />,
    },
  ];

  useEffect(() => {
    if (
      userData?.email &&
      !watchlistsFetched &&
      watchlistStatus !== "loading" &&
      watchlistStatus !== "error"
    ) {
      dispatch(
        getWatchLists(userData["custom:custom_username"], userData?.email),
      );
    }
  }, [userData, watchlists, watchlistStatus, watchlistsFetched, dispatch]);

  return (
    <>
      <PageHeader title="Watchlist" service="insight" />
      <WatchlistSummaryBoard />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginLeft: "auto",
          marginBottom: "1rem",
          flexWrap: "wrap",
          gap: ".5rem",
        }}
      >
        <SearchBox
          wrapperStyle={{ margin: 0, maxWidth: "250px" }}
          value={trendsSearch}
          onChange={searchHandler}
        />
        <div
          style={{
            marginLeft: "auto",
            alignSelf: "flex-end",
            display: "flex",
            alignItems: "center",
            gap: ".5rem",
          }}
        >
          <DisplayModeSwitcher />
          <SortBy options={sortOptions} />
        </div>
      </div>
      <TrendsTable />
      {/*<Trends />*/}
    </>
  );
}

export default InsightWatchlist;
